import { getValidToken } from "./tokenManager";
import config from "./config";

class ApiClient {
  constructor(baseURL) {
    this.baseURL = baseURL;
  }

  async request(endpoint, options = {}) {
    try {
      let token = await getValidToken();
  
      const requestConfig = {
        ...options,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          ...options.headers,
        },
      };
  
      let response = await fetch(
        `${this.baseURL}${endpoint}`,
        requestConfig
      );
  
      if (response.status === 401) {
        window.location.href = "/login";
        throw new Error("Unauthorized");
      }
  
      return response;
  
    } catch (err) {
      const normalizedError =
        err instanceof Error
          ? err
          : new Error(err?.message || "API request failed");
  
      console.error("ApiClient Error:", normalizedError);
      throw normalizedError;
    }
  }

  get(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: "GET" });
  }

  post(endpoint, data, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: "POST",
      body: data ? JSON.stringify(data) : undefined,
    });
  }

  put(endpoint, data, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: "PUT",
      body: data ? JSON.stringify(data) : undefined,
    });
  }

  delete(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: "DELETE" });
  }

  patch(endpoint, data, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: "PATCH",
      body: data ? JSON.stringify(data) : undefined,
    });
  }
}

/* ✅ Named export restored */
export { ApiClient };

/* ✅ Default global API instance */
const apiClient = new ApiClient(config.apiBaseUrl);
export default apiClient;